import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { GeneralCollateralHistory } from '../../interfaces/general-collateral/general-collateral-history';
import { OrderGroupsService } from '../../services/order-groups/order-groups.service';
import { Order } from '../../interfaces/orders/order';

@Component({
    selector: 'lib-general-collateral-history-expandable',
    templateUrl: './general-collateral-history-expandable.component.html',
    styleUrls: ['./general-collateral-history-expandable.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class GeneralCollateralHistoryExpandableComponent implements OnInit {
  @Input() order!: Order;

  protected history: GeneralCollateralHistory[] = [];

  constructor(private orderGroupsService: OrderGroupsService) { }

  ngOnInit(): void {
    this.orderGroupsService.getGeneralCollateralHistory(this.order.orderGroup?.id ?? '')
      .subscribe(history => {
        const indexOfCurrentOrder = history.findIndex(h => this.order.lien?.registrationResults?.some(results => results.registrationNumber === h.registrationNumber));

        if(indexOfCurrentOrder === -1) {
          this.history = history;
        } else {
          this.history = history.slice(0, indexOfCurrentOrder + 1);
        }
      });
  }
}
